import { ChangeEvent, useState } from 'react';
import { FiX } from 'react-icons/fi';
import { City } from '../../pages/home/Home';
import Container from './style';

type CitySelectProps<T> = {
  arrayCities: T[];
  handleSelect: (city: string) => void;
  setOpenModalCities: (value: boolean) => void;
};

const alphabeticOrder = (array: City[]) =>
  array.sort((a, b) => a.nome.localeCompare(b.nome));

const CitySelect = <T extends City>({
  arrayCities,
  handleSelect,
  setOpenModalCities,
}: CitySelectProps<T>) => {
  const [myCities, setMyCities] = useState(alphabeticOrder(arrayCities));

  return (
    <Container>
      <div className="body">
        <button
          type="button"
          className="close-modal"
          onClick={() => setOpenModalCities(false)}
        >
          <FiX size={22} />
        </button>
        <h5>Cidades</h5>
        <div className="container-form">
          <form name="cities">
            {myCities.map(city => (
              <label key={city.id} onChange={() => handleSelect(city.nome)}>
                <input type="radio" value={city.nome} name="city" />
                <span>{city.nome}</span>
              </label>
            ))}
          </form>
        </div>
        <div className="footer-modal">
          <p>Sua cidade não está na lista?</p>
          <a href="malito:ofertou.app@gmail.com">Envie uma mensagem para nosso time</a>
        </div>
      </div>
    </Container>
  );
};

export default CitySelect;
